import { Image } from 'expo-image';
import { StyleSheet, View } from 'react-native';

import { Text, tokens } from '@fhs/ui';
import { LOYALTY_SAVINGS } from '@fhs-legacy/frontend/src/utils/test-ids';

export default function SavingsWithOffer({ savings }: { savings: number }) {
  return (
    <View testID={LOYALTY_SAVINGS} style={styles.savingsContainer}>
      <Image source={require('./cash-sign.webp')} style={styles.dollarSignImage} />
      <Text style={{ color: 'white' }}>
        Saving{' '}
        <Text weight="semibold" style={{ color: 'white' }}>
          ${(savings / 100).toFixed(2)}{' '}
        </Text>
        With Our Special Offer
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  savingsContainer: {
    backgroundColor: tokens.colors.$success,
    height: 49,
    flexDirection: 'row',
    gap: 4,
    alignItems: 'center',
    justifyContent: 'center',
  },
  dollarSignImage: { width: 20, height: 20 },
});
